import { useAuthStore } from '@stores/authStore';
import { QueryClient } from '@tanstack/react-query';

const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          const status =
            (error as { statusCode?: number; response?: { status?: number } } | null)?.statusCode ??
            (error as { response?: { status?: number } } | null)?.response?.status;
          return status !== 403 && failureCount < 3;
        },
      },
      mutations: {
        retry: 0,
      },
    },
  });

/**
 * Vacía la caché de React Query cuando la sesión termina (token → null), venga
 * de donde venga el logout: interceptor 401, logout manual u otra vía. Así los
 * datos de una sesión nunca se sirven a la siguiente en la misma pestaña.
 * Cambiar de team o impersonar cambia el token sin anularlo y no vacía nada.
 */
export const bindQueryClientToSession = (queryClient: QueryClient): (() => void) =>
  useAuthStore.subscribe((state, prevState) => {
    if (prevState.token && !state.token) {
      void queryClient.cancelQueries();
      queryClient.clear();
    }
  });

export default createQueryClient;
